export default __webpack_public_path__ + "static/IBMPlexSans-TextItalic-Latin1-22b03e8f87f9dc4156af48c7813e732b.woff";